import { ComponentsConfig } from "hyam-prismic/types/componentsConfig";

export const componentsConfig: ComponentsConfig = {
  HyamPrismicSliceHeroBackgroundMedia: {},
  HyamPrismicSliceLogoSlider: {}
};
